import { render, staticRenderFns } from "./Changelogs.vue?vue&type=template&id=a1eacbce&"
import script from "./Changelogs.vue?vue&type=script&lang=js&"
export * from "./Changelogs.vue?vue&type=script&lang=js&"
import style0 from "./Changelogs.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports